import { AGENT_PERMISSIONS } from "../../constants";

export const STRATEGIES_AGENT_PERMISSIONS = {
    "UPDATE_PERMISSION": (message, that) => {
        switch(message.PermissionName){
            case AGENT_PERMISSIONS.AllowPlayRecordsOnCallHistory:
                    that.props.setAllowPlayRecordsOnCallHistory(message.PermissionValue);
                break;
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Agent_Permissions.js